module.exports = __webpack_public_path__ + "static/media/menu9.002a7f1d.jpg";